import PropTypes from "prop-types"
import { Col, Input, Label, Row } from "reactstrap"

// The four directory display switches. Shared by the seller's own profile
// (Users/Profile/About) and the admin PVS editor (Admin/Pvs/EditPvs) so the
// PULA team sees exactly what the seller sees.
const DIRECTORY_TOGGLES = [
  {
    id: "showDirectory",
    label: "Show my directory",
    adminLabel: "Show directory page",
    icon: "bx bx-user-circle",
  },
  {
    id: "showContactNumber",
    label: "Show Contact Number",
    icon: "bx bx-phone",
  },
  { id: "showEmail", label: "Show Email", icon: "bx bx-envelope" },
  {
    id: "showWhatsapp",
    label: "Show Whatsapp Number",
    icon: "bx bxl-whatsapp",
  },
]

const DirectoryToggles = ({ values, onChange, locked, variant }) => (
  <Row className="mb-1">
    {DIRECTORY_TOGGLES.map(({ id, label, adminLabel, icon }) => {
      // The three sub-switches only mean anything while the directory page
      // itself is visible.
      const isSubToggle = id !== "showDirectory"
      const disabled = locked || (isSubToggle && !values.showDirectory)
      const active = values[id] && !disabled
      return (
        <Col md="6" key={id}>
          <Label
            className="mb-3 d-flex align-items-center justify-content-between p-3 rounded"
            style={{
              border: `2px solid ${active ? "#880356" : "#dee2e6"}`,
              backgroundColor: disabled
                ? "#f0f0f0"
                : active
                ? "#fff0fa"
                : "#f8f9fa",
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.5 : 1,
              transition: "all 0.2s ease",
            }}
          >
            <span className="d-flex align-items-center gap-2 fw-medium">
              <i
                className={`${icon} fs-5`}
                style={{ color: disabled ? "#aaa" : "#880356" }}
              ></i>
              {variant === "admin" && adminLabel ? adminLabel : label}
            </span>
            <div
              style={{
                width: "46px",
                height: "24px",
                borderRadius: "12px",
                backgroundColor: active ? "#880356" : "#ced4da",
                position: "relative",
                transition: "background-color 0.2s ease",
                flexShrink: 0,
              }}
            >
              <div
                style={{
                  width: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  backgroundColor: "#fff",
                  position: "absolute",
                  top: "3px",
                  left: active ? "25px" : "3px",
                  transition: "left 0.2s ease",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                }}
              />
            </div>
            <Input
              id={id}
              name={id}
              type="checkbox"
              className="d-none"
              checked={!!values[id]}
              onChange={onChange}
              disabled={disabled}
            />
          </Label>
        </Col>
      )
    })}
  </Row>
)

DirectoryToggles.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  locked: PropTypes.bool,
  variant: PropTypes.oneOf(["user", "admin"]),
}

DirectoryToggles.defaultProps = {
  locked: false,
  variant: "user",
}

export default DirectoryToggles
